/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type DenyRiskPolicyBypassRequestSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DenyRiskPolicyBypassRequestSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DenyRiskPolicyBypassRequestSecurity = {
  option1?: DenyRiskPolicyBypassRequestSecurityOption1 | undefined;
  option2?: DenyRiskPolicyBypassRequestSecurityOption2 | undefined;
};

export type DenyRiskPolicyBypassRequestRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type DenyRiskPolicyBypassRequestSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DenyRiskPolicyBypassRequestSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DenyRiskPolicyBypassRequestSecurityOption1$Outbound,
    DenyRiskPolicyBypassRequestSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function denyRiskPolicyBypassRequestSecurityOption1ToJSON(
  denyRiskPolicyBypassRequestSecurityOption1:
    DenyRiskPolicyBypassRequestSecurityOption1,
): string {
  return JSON.stringify(
    DenyRiskPolicyBypassRequestSecurityOption1$outboundSchema.parse(
      denyRiskPolicyBypassRequestSecurityOption1,
    ),
  );
}

/** @internal */
export type DenyRiskPolicyBypassRequestSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DenyRiskPolicyBypassRequestSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DenyRiskPolicyBypassRequestSecurityOption2$Outbound,
    DenyRiskPolicyBypassRequestSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function denyRiskPolicyBypassRequestSecurityOption2ToJSON(
  denyRiskPolicyBypassRequestSecurityOption2:
    DenyRiskPolicyBypassRequestSecurityOption2,
): string {
  return JSON.stringify(
    DenyRiskPolicyBypassRequestSecurityOption2$outboundSchema.parse(
      denyRiskPolicyBypassRequestSecurityOption2,
    ),
  );
}

/** @internal */
export type DenyRiskPolicyBypassRequestSecurity$Outbound = {
  Option1?: DenyRiskPolicyBypassRequestSecurityOption1$Outbound | undefined;
  Option2?: DenyRiskPolicyBypassRequestSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DenyRiskPolicyBypassRequestSecurity$outboundSchema: z.ZodMiniType<
  DenyRiskPolicyBypassRequestSecurity$Outbound,
  DenyRiskPolicyBypassRequestSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DenyRiskPolicyBypassRequestSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DenyRiskPolicyBypassRequestSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function denyRiskPolicyBypassRequestSecurityToJSON(
  denyRiskPolicyBypassRequestSecurity: DenyRiskPolicyBypassRequestSecurity,
): string {
  return JSON.stringify(
    DenyRiskPolicyBypassRequestSecurity$outboundSchema.parse(
      denyRiskPolicyBypassRequestSecurity,
    ),
  );
}

/** @internal */
export type DenyRiskPolicyBypassRequestRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const DenyRiskPolicyBypassRequestRequest$outboundSchema: z.ZodMiniType<
  DenyRiskPolicyBypassRequestRequest$Outbound,
  DenyRiskPolicyBypassRequestRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function denyRiskPolicyBypassRequestRequestToJSON(
  denyRiskPolicyBypassRequestRequest: DenyRiskPolicyBypassRequestRequest,
): string {
  return JSON.stringify(
    DenyRiskPolicyBypassRequestRequest$outboundSchema.parse(
      denyRiskPolicyBypassRequestRequest,
    ),
  );
}
